import { useEffect, useMemo } from 'react';
import { safeDecodeUrlParam } from '@/lib/redirect';
import { useThemeConfig } from '@/components/ui/theme-config-provider';

/**
 * Pagina ponte che ripristina il frammento `#access_token`
 * dopo il click tracking del provider email.
 * @returns Elemento di stato con reindirizzamento automatico.
 */
export default function VerifyBridge() {
  const { theme } = useThemeConfig();
  const target = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return safeDecodeUrlParam(params.get('u'));
  }, []);

  useEffect(() => {
    if (target) window.location.replace(target);
  }, [target]);

  return (
    <main
      aria-busy={!target}
      className="min-h-dvh flex items-center justify-center p-6"
      style={{ backgroundColor: theme.backgroundColor, color: theme.textColor }}
    >
      <div
        role="status"
        className="w-full max-w-md rounded-lg border p-5 text-center"
        style={{ backgroundColor: theme.cardBackgroundColor, borderColor: theme.borderColor }}
      >
        <h1 className="text-lg font-semibold" style={{ color: theme.sectionTitleColor }}>
          Reindirizzamento in corso…
        </h1>
        {!target && (
          <p role="alert" className="mt-2" style={{ color: theme.errorColor }}>
            Link non valido o mancante.
          </p>
        )}
        {target && (
          <p className="mt-4 text-sm" style={{ color: theme.sectionTextColor }}>
            Se non vieni reindirizzato{' '}
            <a className="underline" href={target} style={{ color: theme.primaryColor }}>
              clicca qui
            </a>
            .
          </p>
        )}
      </div>
    </main>
  );
}
